<template lang="pug">
  div(class="sound" :style="soundStyle")
    div(class="container service bg-white" style="min-height: calc(100vh - 190px);")
      router-view
</template>

<script>
import urlBodyBg from '@/assets/bg.png'
export default {
  name: 'Sound',
  data () {
    return {
      urlBodyBg
    }
  },
  computed: {
    soundStyle () {
      return {
        backgroundImage: `url(${this.urlBodyBg})`
      }
    }
  }
}
</script>

<style scoped>
.monthly-detail-host {
  min-height: 100vh;
}
</style>
